import React from 'react';
import classNames from 'classnames';
import styles from './ScrollContainer.module.scss';

export const ScrollContainer = ({
    children, className, maxHeight = 675
}: Props) => (
    <div className={classNames(styles.default, className)}
        style={{ maxHeight }}>
        {children}
    </div>
);

type Props = {
    children: React.ReactNode,
    maxHeight?: string | number,
    className?: string,
};